import {
  Component,
  ViewChild,
  Input,
  ElementRef,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  TemplateRef,
} from "@angular/core";
import {
  SortService,
  GridComponent,
  FilterService,
  ToolbarService,
  EditService,
  GroupService,
  EditSettingsModel,
  PageSettingsModel,
  PageService,
  AggregateService,
  GroupSettingsModel,
  ResizeService,
} from "@syncfusion/ej2-angular-grids";
import {
  formatNumber}
  from '@angular/common';
import { SharedService } from "src/app/core/services/shared.service";
import Swal from "sweetalert2";
import { Observable, Subscription } from "rxjs";
import {
  NgbModal,
  NgbModalRef,
  NgbOffcanvas,
  NgbOffcanvasRef,
} from "@ng-bootstrap/ng-bootstrap";
import { FiltrocanvasComponent } from "../filtrocanvas/filtrocanvas.component";
import { FiltrocampoComponent } from "../filtrocampo/filtrocampo.component";
import { formatDate } from "@angular/common";
import { DropzoneComponent } from "../dropzone/dropzone.component";
import { MenuEvent } from "src/app/core/services/menuevent.service";
import { MenuService } from "src/app/core/services/menu.service";
import { EventService } from "src/app/core/services/event.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ButtonComponent } from "@syncfusion/ej2-angular-buttons";
import { ReportesComponent } from "../reportes/reportes.component";
import { L10n, setCulture } from "@syncfusion/ej2-base";
import es from "@syncfusion/ej2-locale/src/es.json";

setCulture("es");
@Component({
  selector: "app-lista-editable-sync",
  templateUrl: "./lista-editable-sync.component.html",
  styleUrl: "./lista-editable-sync.component.scss",
  providers: [
    AggregateService,
    SortService,
    FilterService,
    ToolbarService,
    EditService,
    GroupService,
    PageService,
    ResizeService
  ],
})
export class ListaEditableSyncComponent {
  WsMsDataInterno: string = "";
  mostrarbreitem: boolean = false;
  TituloPantalla: string = "";
  CNT05DES: any;
  M05DES: any;
  // mospina 21-10-26 Breadcrumb compañía/sede
  get companiaActual(): string { return localStorage.getItem("X-AVATAR-CNT05DES") || ''; }
  get sedeActual(): string { return localStorage.getItem("X-AVATAR-M05DES") || ''; }
  toolbarOriginal: any;
  tipo_pantalla: string = "";

  respFiltros = [];
  respFiltrosAvanzados = [];

  offcanvasRef: NgbOffcanvasRef = null;

  strEventListener: string;
  Mostrartitulofiltro = false;
  formFiltros = null;
  reportes: Array<string> = [];
  estructura: Observable<any>;
  tableData2: Array<any>;
  toolbarcampomodal: any;
  form_template$: Observable<any>;
  WsLlavesModal: string = "";
  strWsURLModal: string = "";
  tipoReporte = null;
  modalRef: NgbModalRef;
  ColumnasSN = [];
  llaves: Array<string> = [];
  tableData3: Array<any> = [];
  CNT05COD: any;
  M05COD: any;
  MostrarFiltroPrincipal: any;
  blnFiltrosAbiertosHorizontal: boolean = false;

  boton: Array<string> = [];
  tipo: Array<string> = [];
  evento: Array<string> = [];
  tooltip: Array<string> = [];
  icono: Array<string> = [];

  permitir_click_lista: string = "";
  UrlClickLista: string = "";
  UrlBottomBar: any;
  operaciones: any;
  filtrosReporte: Array<string> = [];

  favorito_pantalla: string = "";
  ActivarFiltro: string = "";
  ActivarFavorito: string = "";
  MostrarReportes: string = "";
  Select_grabar: any;
  SYS02TUT = "";
  SYS41ARC = [];
  dashboard = { CHARTS: [], REPORTES: [] };
  filtro_guardado = [];
  BottomBarData: any;

  safeURL: SafeResourceUrl;
  blnFiltrosAbiertos: boolean = false;
  order_mostrar: boolean = false;
  lineaEditar = -1;
  currentPage: number;
  itemsPerPage: number = 10;
  number = [10, 20, 40, 60, 100];
  blnAccionbuscar = 0;
  currentPDF: any;

  suscription: Subscription = null;

  @Input() breadCrumbItems: Array<{}>;
  @Input() A04CDE = null;
  @Input() mostrarModal: boolean = false;
  @Input() MsDetalle: string = "N";
  @Input() EsExterna: boolean = false;

  @ViewChild(FiltrocampoComponent) child: FiltrocampoComponent;
  @ViewChild("contenidocampo") contenidocampo: TemplateRef<any>;
  @ViewChild("contenido") contenido: TemplateRef<any>;
  @ViewChildren("chkTabla") objChecks: QueryList<ElementRef>;
  @ViewChild(ReportesComponent) reportesComponent!: ReportesComponent;
  @ViewChild('ListaEditableSync') public grid?: GridComponent;

  // para el paginador
  @ViewChild("grid")
  public pageOptions?: PageSettingsModel;
  @ViewChild("button") public button?: ButtonComponent;

  @Output() AbrirNuevoNav = new EventEmitter<string>();
  @Output() RetornoModal = new EventEmitter();

  @Input() WORKFLOW: any; // almora 2023.07.01 Información de Workflow
  @Input() DOC10ARC: any; // almora 2023.07.05 Información de Cejilla Documentos
  @Input() PRO10ARC: any; // almora 2024.01.31 Información de Cejilla Gantt Proyectos
  @Input() SYS02CON_PAPA_LD: string; // almora 2024.06.19 Guardo SYS02CON de la tabla principal, se carga si soy Lista Detalle desde Wizard
  @Input() SYS02TIP: any;

  ShowLoadingIndicator = true;

  @Input() WsURL: string = "";
  @Input() WsLlaves: any = "";

  public filterSettings: Object;
  public pageSettings: Object;
  public formatoptions: Object;
  public data: Object[] = [];

  public toolbar: string[]; // Toolbar
  public columnas: string[] = []; // Columnas
  public toolbarResp: any;
  public estructuraResp: any;
  public intSYS02CON: string;
  TiempoBackend: number = 0;
  TiempoInicio = new Date();
  TiempoFinal = new Date();
  anchoAcciones: number = 70;

  public groupOptions: GroupSettingsModel = {};

  public regla_fecha_obligatorio: {
    required: true;
    type: "dateTime";
    format: "dd/MM/y";
    message: "text";
  };
  public regla_fecha_opcional: {
    required: false;
    type: "dateTime";
    format: "dd/MM/y";
  };
  public regla_numero_obligatorio: {
    required: true;
    number: true;
    message: "text";
  };
  public regla_numero_opcional: { required: false; number: true };
  public regla_texto_obligatorio: { required: true; message: "text" };
  public regla_texto_opcional: { required: false };

  constructor(
    private dataService: SharedService,
    public menuService: MenuService,
    private eventService: EventService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private menuEvent: MenuEvent,
    private offcanvasService: NgbOffcanvas
  ) {
    this.obtener_localstorage();
  }

  public isEmailValid: boolean = false;
  public isFeedbackTextValid: boolean = false;
  public isUserNavigatingReverse: boolean = false;
  public isCurrentStepValid: boolean = false;
  public regex: RegExp = new RegExp(
    "^[A-Za-z0-9._%+-]{1,}@[A-Za-z0-9._%+-]{1,}"
  );

  public editSettings?: EditSettingsModel;

  public msFormat: any = [];

  ngOnInit(): void {
    this.obtener_localstorage();
    if (this.MostrarFiltroPrincipal == "false") {
      this.blnFiltrosAbiertosHorizontal;
    } else {
      this.blnFiltrosAbiertosHorizontal = !this.blnFiltrosAbiertosHorizontal;
    }
    this.Mostrartitulofiltro = true;

    this._fetchData();

    this.filterSettings = { type: "Excel" };
    this.pageSettings = { pageCount: 5, pageSize: 10 };
    this.formatoptions = { type: "dateTime", format: "M/dd/y hh:mm a" };

    L10n.load(es);
  }

  clickHandler(value: any): void {
    (this.grid as GridComponent).pageSettings.pageSize = parseInt(value, 10);
  }

  EventoCerrarMSInterno(objRefrescar: any) {
    this.WsMsDataInterno = "";
    if (typeof objRefrescar === "boolean") {
      if (objRefrescar) this._fetchData();
    } else if (typeof objRefrescar === "object") {
      if (objRefrescar.WKF10COD)
        this.WORKFLOW[0].WKF10COD = objRefrescar.WKF10COD;
      if (objRefrescar.DOC10COD)
        this.DOC10ARC[0].DOC10COD = objRefrescar.DOC10COD;
      if (objRefrescar.PRO10COD)
        this.PRO10ARC[0].PRO10COD = objRefrescar.PRO10COD;
      this._fetchData();
    }
  }

  getSafeUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.currentPDF);
  }

  RetornoModalLista(event) {
    // Este metodo se llama en el Cerrar de la Lista Modal
    this._fetchData();
  }

  obtener_localstorage() {
    this.CNT05COD = localStorage.getItem("X-AVATAR-CNT05COD");
    this.M05COD = localStorage.getItem("X-AVATAR-M05COD");
    this.CNT05DES = localStorage.getItem("X-AVATAR-CNT05DES");
    this.M05DES = localStorage.getItem("X-AVATAR-M05DES");
    this.MostrarFiltroPrincipal = localStorage.getItem(
      "X-AVATAR-MOSTRARFILTRO"
    );

    if (
      this.CNT05COD == "" ||
      this.CNT05COD == undefined ||
      this.M05COD == "" ||
      this.M05COD == undefined
    ) {
      Swal.fire({
        title: "Error",
        text: "Por favor Seleccione una Compañia y Sede",
        icon: "error",
      });
      this.menuEvent.abrirmodalcompaniaysede("");
      this.mostrarbreitem = true;
    } else {
      this.mostrarbreitem = false;
    }
  }

  retornaObservable(form_template) {
    const obs$ = new Observable((observer) => {
      observer.next(form_template);
    });
    return obs$;
  }

  GrabarFavorito() {
    if (this.favorito_pantalla == "N") {
      this.EventoWsInsert();
    } else {
      this.EventoWsDelete();
    }
  }

  Mostrarboton(index) {
    this.lineaEditar = index;
  }

  buscardes(event, campo, index, sys03edi, UrlOnChange) {
    if (sys03edi != "S" || UrlOnChange == "") return;
    let campos = {};

    for (const col of this.ColumnasSN) {
      for (const i in this.tableData2) {
        if (this.tableData2[i].INDEX == index) {
          campos[col.A03COD] = String(
            this.tableData2[i][col.A03COD]
          ).replaceAll(",", "");
          break;
        }
      }
    }
    campos[campo] = event.target.value;

    let jsonFiltros = { LLAVES: [campos], OPERACION: "BUSCAR_DESCRIPCION" };

    this.dataService
      .ConsultarWS(UrlOnChange, JSON.stringify(jsonFiltros))
      .subscribe(
        (datosResp: any) => {
          if (datosResp.NOTIFICACION != "") {
            Swal.fire({
              html:
                '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                '<div class="col-5">' +
                ' <img src="assets/images/image-notifiacion.jpg"> </img>' +
                "</div>" +
                ' <div class="col-7">' +
                "<h3>Advertencia</h3><br>" +
                " <p>" +
                datosResp.NOTIFICACION +
                "</p>" +
                " </div> ",
            });
          }
          for (const key in this.tableData2) {
            if (this.tableData2[key].INDEX == index) {
              let keys = Object.keys(datosResp.DATA[0]);
              for (const k in keys) {
                this.tableData2[key][keys[k]] = datosResp.DATA[0][keys[k]];
              }
            }
          }
        },
        (error) => {
          Swal.fire({
            html:
              '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-5">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              "</div>" +
              ' <div class="col-7">' +
              "<h3>Error</h3><br>" +
              " <p>" +
              error +
              "</p>" +
              " </div> ",
          });
        }
      );
  }

  EventoWsInsert() {
    this.dataService
      .ConsultarWS("api/mantenimientos/Favoritos/ADD/" + this.intSYS02CON)
      .subscribe(
        (datosResp: any) => {
          // almora 202.03.21 No necesito recargar la página
          this.favorito_pantalla = "S";
          Swal.fire({
            position: "bottom-end",
            toast: true,
            icon: "success",
            text: "Dato Grabado exitosamente",
            showConfirmButton: false,
            timer: 5000,
          });
        },
        (error) => {
          Swal.fire({
            title: "Error",
            text: error,
            icon: "error",
          });
        }
      );
  }

  EventoWsDelete() {
    this.dataService
      .ConsultarWS("api/mantenimientos/Favoritos/DEL/" + this.intSYS02CON)
      .subscribe(
        (datosResp: any) => {
          // almora 202.03.21 No necesito recargar la página
          this.favorito_pantalla = "N";
          Swal.fire({
            position: "bottom-end",
            toast: true,
            icon: "success",
            text: "Dato Eliminado exitosamente",
            showConfirmButton: false,
            timer: 5000,
          });
        },
        (error) => {
          Swal.fire({
            title: "Error",
            text: error,
            icon: "error",
          });
        }
      );
  }

  EventoClickOperacion(operacion: any, index, i?) {
    const btn = document.getElementById(index) as HTMLButtonElement;
    if (operacion.URL != undefined) {
      let arr: any[] = [];
      let llaves = this.DemeLlavesIndexJSON(index);
      if (operacion.Evento == "UPDATE_GENERICO" && this.permitir_click_lista == "S") {
        arr.push(llaves);

        var jsonFiltros = this.toJSON("SELECT", arr, operacion.URL);

        // Emito el evento para abrir un nuevo tab
        this.AbrirURL(jsonFiltros);
      } else if (operacion.Evento == "EDITAR_LINEA") {
        let inputs = document.getElementsByClassName(index);
        for (const key in inputs) {
          if (inputs[key].id != undefined) {
            let attr = inputs[key].id.split("+");
            llaves[attr[0]] = (<HTMLInputElement>document.getElementById(inputs[key].id)).value;
          }
        }
        arr.push(llaves);
        this.EjecutarAccion(arr, i, false, btn);

        document.getElementById(index).style.display = 'none';
      } else if (operacion.Evento == "IMPRIMIR") {
        arr.push(llaves);
        let parametros = operacion.URL.split("/");
        let num = parametros.length;
        this.VerReporte(parametros[num - 3], parametros[num - 2], parametros[num - 1], "PDF", arr);
      } else if (operacion.Evento == "ABRIR_MS") {
        arr.push(llaves);

        // Armo el JSON
        let json = this.toJSON("SELECT", arr, operacion.URL);

        this.AbrirURL(json);
      }
      else if (operacion.Evento == "DELETE_WS" || operacion.Evento == "DELETE_GENERICO" || operacion.Evento == "ANULAR") {
        var mensaje = "Está seguro de Eliminar?"
        if (operacion.Evento == "ANULAR") mensaje = "Está seguro de anular?"

        Swal.fire({
          title: mensaje,
          text: "No podrás revertir esto!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          cancelButtonText: 'No, cancelar!',
          confirmButtonText: operacion.Evento == "ANULAR" ? 'Si, anularlo' : 'Si, eliminarlo',
        }).then((result) => {
          if (result.isConfirmed) {
            arr.push(llaves);

            this.EjecutarAccion(arr, i, true, btn);
          }
        })
      } else if (operacion.Evento == "INSERT") {
        arr.push(llaves);

        let arrLlaves = "  \"FILTROS_OPCIONALES\"   : [{}]" +
          ", \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(this.WsLlaves);

        this.EjecutarAccion(arr, i, true, btn, arrLlaves);
      } else if (operacion.Evento == "DESCARGAR") {
        arr.push(llaves);
        this.EjecutarAccion(arr, i, true, btn, null, 'descarga');
      } else if (operacion.Evento == "MI_WORKFLOW") {
        let url = "api/mantenimientos/MantenimientoGenerico/" + llaves['SYS02CON'];
        let json = this.toJSON("SELECT", JSON.parse('[' + llaves['WKF10JSO'] + ']'), url);
        this.AbrirURL(json);
      } else {
        arr.push(llaves);

        this.EjecutarAccion(arr, i, true, btn);
      }
    }

  }

  countNumber(event: any) {
    this.itemsPerPage = event;
  }

  EjecutarAccion(arr: any[], i: number, b, btn?, extras?, descarga?) {
    if (arr.length > 0) {
      var jsonFiltros = this.toJSON(this.operaciones[i].Evento, arr, null, null, extras);
      var operacion = this.operaciones[i].Evento;
      if (operacion == "INSERT_GENERICO") operacion = "Campo Insertado";
      else if (operacion == "UPDATE_GENERICO") operacion = "Campo Actualizado"
      else if (operacion == "DELETE_GENERICO") operacion = "Eliminado";

      this.dataService.ConsultarWS(this.operaciones[i].URL, jsonFiltros, btn).subscribe(
        (datosResp: any) => {
          if (b != false){
            this.currentPage = 1;
            this._fetchData(this.formFiltros);
          }
          if (descarga == null) {
            //alertas
            Swal.fire({
              toast: true,
              position: 'bottom-end',
              icon: 'success',
              text: operacion + ' Correctamente',
              showConfirmButton: false,
              timer: 3000
            });
          } else {
            const blob = this.dataURItoBlob(datosResp.base64, datosResp.tipo);
            let fileURL = URL.createObjectURL(blob);
            if (datosResp.tipo == 'application/pdf') {
              window.open(fileURL, '_blank');
            } else {
              let link = document.createElement('a');
              if (datosResp.nombre != null) {
                link.download = datosResp.nombre;
              } else {
                let tipoPartes = datosResp.tipo.split('/');
                if (tipoPartes.length > 1) {
                  link.download = 'documento.' + tipoPartes[1];
                } else {
                  link.download = 'documento';
                }
              }
              link.href = fileURL;
              link.click();
            }
          }
        },
        error => {
          Swal.fire({
            title: 'Error',
            text: error,
            icon: 'error',
          });
        }
      );
    } else {
      alert('Debe seleccionar los registros a eliminar');
    }
  }

  DemeCamposIndexJSON(index) {
    let row = null;

    for (const key in this.tableData2) {
      if (this.tableData2[key].INDEX == index) {
        row = this.tableData2[key];
        break;
      }
    }
    var arr = {};

    for (var i in row) {
      for (let j = 0; j < this.tableData3.length; j++) {
        if (i == this.tableData3[j].codigo) {
          var valor = "";
          valor = this.tableData3[j].des.find(
            (element) => element.A09DES == row[i]
          );
          valor = valor["A09COD"];
          row[i] = valor;
          break;
        }
      }
    }

    return row;
  }

  ordenasc(val) {
    this.tableData2.sort((a, b) => a[val] - b[val]);
    this.tableData2.sort((a, b) => {
      if (isNaN(Number(a[val])) && isNaN(Number(b[val]))) {
        if (a[val].toLowerCase() < b[val].toLowerCase()) {
          return 1;
        }
        if (a[val].toLowerCase() > b[val].toLowerCase()) {
          return -1;
        }
        return 0;
      }
    });
    this.order_mostrar = false;
  }

  BuscarAvanzado() {
    if (this.respFiltros[0].FiltrosAvanzado.length > 0) {
      this.blnAccionbuscar++;
    } else {
      if (this.formFiltros != null) {
        this._fetchData(this.formFiltros);
      } else {
        this._fetchData();
      }
    }
  }

  limpiarbusqueda() {
    this.formFiltros = null;
    localStorage.removeItem("filtro" + this.intSYS02CON);
    localStorage.removeItem("busqueda" + this.intSYS02CON);
    this.child?.myFormGroup.reset();
    let limpiar = {};
    this._fetchData(limpiar);

    this.objChecks.forEach((objCheck) => {
      if (objCheck.nativeElement.checked) {
        let index = objCheck.nativeElement.value;
        if (index == -1) {
          objCheck.nativeElement.checked = false;
        }
      }
    });
  }

  abrirAyuda() {

    // mospina 15-04-2026 se obtiene localstorage campo 
    let CLITUT = localStorage.getItem('CLITUT');

    if (this.SYS02TUT != null && this.SYS02TUT != '') {
      window.open(this.SYS02TUT + "?c=" + CLITUT, '_blank');
    }
  }

  EventoClickLista(event, index) {
    if (this.mostrarModal) {
      let arr: any[] = [];
      let llaves = this.DemeLlavesIndexJSON(index);
      arr.push(llaves);
      this.RetornoModal.emit(arr);
    } else {
      if (this.permitir_click_lista == "S") {
        let arr: any[] = [];
        let llaves = this.DemeLlavesIndexJSON(index);
        for (const property in this.WsLlaves[0]) {
          if (llaves[property] == null) {
            llaves[property] = this.WsLlaves[0][property];
          } else {
            llaves[property + "_1"] = this.WsLlaves[0][property];
          }
        }
        arr.push(llaves);

        // Armo el JSON
        let json = this.toJSON("SELECT", arr, this.UrlClickLista);

        // Emito el evento para abrir un nuevo tab
        this.AbrirURL(json);
      }
    }
  }

  ordendes(val) {
    this.tableData2.sort((a, b) => b[val] - a[val]);
    this.tableData2.sort((a, b) => {
      if (isNaN(Number(a[val])) && isNaN(Number(b[val]))) {
        if (a[val].toLowerCase() > b[val].toLowerCase()) {
          return 1;
        }
        if (a[val].toLowerCase() < b[val].toLowerCase()) {
          return -1;
        }
        return 0;
      }
    });
    this.order_mostrar = true;
  }

  checktodos(event) {
    let bandera = false;
    if (event.target) {
      // almora 2023.04.13 Fix
      if (event.target.checked) {
        bandera = true;
      }
    }
    for (let index = 0; index < this.tableData2.length; index++) {
      this.tableData2[index].checkado = bandera;
    }
  }

  cerrarmodal(event) {
    this.blnFiltrosAbiertosHorizontal = !this.blnFiltrosAbiertosHorizontal;
    this.obtener_localstorage();
  }

  open() {
    this.offcanvasRef = this.offcanvasService.open(FiltrocanvasComponent, {
      backdrop: true,
      position: "end",
      scroll: true,
      backdropClass: "bg-transparent",
      panelClass: "scroll-canvas",
    });
    this.offcanvasRef.componentInstance.form_template = this.respFiltros;
    this.offcanvasRef.componentInstance.strListener = this.strEventListener;
    this.offcanvasRef.componentInstance.blnMostrarBusqueda =
      this.tipo_pantalla != "REPORTE";
    this.offcanvasRef.componentInstance.TipoPantalla = this.tipo_pantalla;
    this.offcanvasRef.componentInstance.Mostrartitulofiltro =
      this.Mostrartitulofiltro;
    this.offcanvasRef.componentInstance.formFiltros = this.formFiltros;
    this.offcanvasRef.componentInstance.reportes = this.reportes;
    this.offcanvasRef.componentInstance.WsLlaves = this.WsLlaves;
    this.offcanvasRef.componentInstance.SYS02CON = this.intSYS02CON;
    this.offcanvasRef.componentInstance.estructura = this.estructura;
    this.offcanvasRef.componentInstance.filtrosAvanzados =
      this.child?.DemeFormulario();
    this.offcanvasRef.result
      .then((result) => {
        this.formFiltros = result;
        this._fetchData(this.isObject(result) ? result : JSON.parse(result));
      })
      .catch(() => {});
    this.offcanvasRef.componentInstance.abrirNav.subscribe((json) => {
      this.AbrirNuevoNav.emit(json);
    });
  }

  isObject(obj) {
    return obj !== undefined && obj !== null && obj.constructor == Object;
  }

  _fetchData(filtros?: any) {
    this.ShowLoadingIndicator = true;

    this.TiempoInicio = new Date();
    this.TiempoFinal = new Date();

    if (filtros == null) {
      filtros = JSON.parse("{  }");
    }

    if (this.WsLlaves == null || this.WsLlaves == "") this.WsLlaves = [];

    let objFiltros = JSON.parse(
      '{   "FILTROS_OPCIONALES"   : [' +
        JSON.stringify(this.formatearFormulario(filtros)) +
        "]" +
        (this.WORKFLOW != null
          ? ', "WORKFLOW" : ' + JSON.stringify(this.WORKFLOW)
          : "") +
        (this.DOC10ARC != null
          ? ', "DOC10ARC" : ' + JSON.stringify(this.DOC10ARC)
          : "") +
        (this.PRO10ARC != null
          ? ', "PRO10ARC" : ' + JSON.stringify(this.PRO10ARC)
          : "") +
        (this.SYS02CON_PAPA_LD != null
          ? ', "SYS02CON_PAPA_LD" : ' + JSON.stringify(this.SYS02CON_PAPA_LD)
          : "") +
        ', "FILTROS_OBLIGATORIOS" : ' +
        JSON.stringify(this.WsLlaves) +
        "}"
    );

    this.dataService.ConsultarWS(this.WsURL, objFiltros).subscribe(
      (datosResp: any) => {
        this.intSYS02CON = datosResp.SYS02CON;

        // Toolbar
        let msToolbar: any = [];
        let msColumnas: any = [];
        let msGroup: any = [];
        let blnUpdate: boolean = false;
        let blnInsert: boolean = false;
        let blnDelete: boolean = false;

        this.llaves = [];
        this.ColumnasSN = [];
        this.boton = [];
        this.tipo = [];
        this.evento = [];
        this.tooltip = [];
        this.icono = [];

        this.permitir_click_lista = datosResp.PermitirClickLista;
        this.UrlClickLista = datosResp.UrlClickLista;
        this.UrlBottomBar = datosResp.UrlBottomBar;
        this.tableData2 = datosResp.DataTable;
        this.estructura = datosResp.Estructura;
        this.operaciones = datosResp.Operaciones;
        this.reportes = datosResp.Reportes;
        this.filtrosReporte = datosResp.Filtros;
        this.toolbarResp = datosResp.Toolbar;
        this.estructuraResp = datosResp.Estructura;
        this.tipo_pantalla = datosResp.Tipo;
        this.favorito_pantalla = datosResp.Favorito;
        this.ActivarFiltro = datosResp.ActivarFiltro;
        this.ActivarFavorito = datosResp.ActivarFavorito;
        this.intSYS02CON = datosResp.SYS02CON;
        this.TituloPantalla = datosResp.SYS02DES;
        this.MostrarReportes = datosResp.MostrarReportes;
        this.Select_grabar = datosResp.SYS20ARC;
        this.SYS02TUT = datosResp.SYS02TUT;
        this.SYS41ARC = datosResp.SYS41ARC;
        if (datosResp.DashBoard != undefined) {
          if (datosResp.DashBoard.length > 0) {
            this.dashboard = datosResp.DashBoard[0];
          }
        }

        if (this.operaciones) {
          const botonesVisibles = this.operaciones.filter(op => op.SYS16MET === 'S').length;
          this.anchoAcciones = botonesVisibles <= 1 ? 70 : botonesVisibles * 45;
        }

        // Registro la subscription
        if (this.suscription == null) {
          this.strEventListener = this.intSYS02CON;
          localStorage.removeItem("busqueda" + this.strEventListener);
          this.suscription = this.eventService.subscribe(
            "EVENTO_REFRESAR_LISTA_" + this.strEventListener,
            (data) => {
              let busqueda = this.obtenerBusqueda(this.strEventListener);
              if (busqueda != null) {
                data = busqueda;
              } else {
                if (this.formFiltros != null) {
                  data = this.formatearFormulario(this.formFiltros);
                }
              }
              this._fetchData(this.isObject(data) ? data : JSON.parse(data));
            }
          );
        }

        //this.toolbarResp =  datosResp.Toolbar[0].NORMALES;
        this.TiempoBackend = datosResp.TiempoBackend;

        for (let i = 0; i < datosResp.Toolbar[0].NORMALES.length; i++) {
          if (datosResp.Toolbar[0].NORMALES[i].Tipo === "I") {
            blnInsert = true;
            msToolbar.push("Add");
          } else if (datosResp.Toolbar[0].NORMALES[i].Tipo === "A") {
            blnInsert = true;
            msToolbar.push("Add");
          } else if (datosResp.Toolbar[0].NORMALES[i].Tipo === "D") {
            blnDelete = true;
            msToolbar.push("Delete");
          } else if (datosResp.Toolbar[0].NORMALES[i].Tipo === "E") {
            blnUpdate = true;
            msToolbar.push("Edit");
          }
        }

        msToolbar.push("Update");
        msToolbar.push("Cancel");

        this.toolbar = msToolbar;
        this.editSettings = {
          allowEditing: true,
          allowAdding: blnInsert,
          allowDeleting: blnDelete,
          showAddNewRow: false,
          mode: "Normal",
        };

        msColumnas.push(
          JSON.parse(
            '{ "A03COD"    :"",' +
              '  "A03DES"   :"",' +
              '  "REGLA"    :"",' +
              '  "TIPO"     :"checkbox",' +
              '  "EDITABLE" :"N",' +
              '  "OPERACION"    :"",' +
              '  "WIDTH"    :40,' +
              '  "A03PKY"   :""}'
          )
        );

        for (let i = 0; i < datosResp.Estructura.length; i++) {
          if (datosResp.Estructura[i].A03PKY === "S") {
            this.llaves.push(datosResp.Estructura[i].A03COD);
          }

          if (datosResp.Estructura[i].A03VIS === "S") {
            let regla = false;
            let rules: object;
            let formato = "";
            let editType = "";
            let editable =
              datosResp.Estructura[i].SYS03EDI == ""
                ? "N"
                : datosResp.Estructura[i].SYS03EDI;
            let operacion = datosResp.Estructura[i].SYS03OPE;
            rules = { required: false };

            if (datosResp.Estructura[i].SYS03TIP === "C") {
              if (
                datosResp.Estructura[i].SYS03REQ === "S" ||
                datosResp.Estructura[i].A04NUL === "N"
              ) {
                rules = { required: true };
              } else {
                rules = { required: false };
              }
            } else if (datosResp.Estructura[i].SYS03TIP === "N") {
              editType = "number";
              formato = "N2";
              if (
                datosResp.Estructura[i].SYS03REQ === "S" ||
                datosResp.Estructura[i].A04NUL === "N"
              ) {
                rules = { required: true };
              } else {
                rules = { required: false };
              }
            } else if (datosResp.Estructura[i].SYS03TIP === "F") {
              formato = "dd/MM/yyyy";
              editType = "datepicker";
              if (
                datosResp.Estructura[i].SYS03REQ === "S" ||
                datosResp.Estructura[i].A04NUL === "N"
              ) {
                rules = { required: true };
              } else {
                rules = { required: false };
              }
            }

            if (datosResp.Estructura[i].SYS03POS == "A") {
              msGroup.push(datosResp.Estructura[i].A03COD);
            }

            if (datosResp.Estructura[i].SYS03TIP == "N") {
              this.msFormat.push(datosResp.Estructura[i].A03COD);
            }

            if (
              datosResp.Estructura[i].A09AMF.length > 0 &&
              datosResp.Estructura[i].A03PKY == "N"
            ) {
              this.tableData3.push({
                codigo: datosResp.Estructura[i].A03COD,
                des: datosResp.Estructura[i].A09AMF,
              });
            }

            let arr = {
              A03COD: datosResp.Estructura[i].A03COD,
              A03DES: datosResp.Estructura[i].A03DES,
              REGLA: rules,
              FORMATO: formato,
              EDITTYPE: editType,
              EDITABLE: editable,
              OPERACION: operacion,
              A03PKY: "N",
            };

            msColumnas.push(arr);
          }
        }

        for (let j = 0; j < this.tableData2.length; j++) {
          this.tableData2[j].checkado = false;
          for (let k = 0; k < this.tableData3.length; k++) {
            if (this.tableData2[j][this.tableData3[k].codigo] != undefined) {
              for (let w = 0; w < this.tableData3[k].des.length; w++) {
                if (
                  this.tableData3[k].des[w].A09COD ==
                  this.tableData2[j][this.tableData3[k].codigo]
                ) {
                  this.tableData2[j][this.tableData3[k].codigo] =
                    this.tableData3[k].des[w].A09DES;
                }
              }
            }
          }
        }

        if (datosResp.Operaciones !== undefined) {
          for (let i = 0; i < datosResp.Operaciones.length; i++) {
            this.boton.push(datosResp.Operaciones[i].boton);
            this.tipo.push(datosResp.Operaciones[i].Tipo);
            this.evento.push(datosResp.Operaciones[i].Evento);
            this.tooltip.push(datosResp.Operaciones[i].Tooltip);
            this.icono.push(datosResp.Operaciones[i].icono);
          }

          if (this.mostrarModal) {
            this.form_template$ = this.retornaObservable(datosResp.Filtros);
          } else {
            this.respFiltros = datosResp.Filtros;
            this.respFiltrosAvanzados = datosResp.Filtros[0];
          }
        }

        // Ojo, tengo que asignar los datos antes que las columnas
        this.data = datosResp.DataTable;

        // formato de valores numericos
        this.msFormat.forEach((elementFormat) => {
          this.tableData2.forEach((elementData) => {
            elementData[elementFormat] = parseFloat(
              elementData[elementFormat].replace(/,/g, "")
            );
          });
        });

        // Asigno las columnas
        this.columnas = msColumnas;
        console.log(this.columnas, "columnas");

        // columnas para agrupamiento
        this.groupOptions = { showDropArea: true, columns: msGroup };

        // Apago el loader
        this.ShowLoadingIndicator = false;

        this.TiempoFinal = new Date();

        this.formFiltros = JSON.parse(
          localStorage.getItem("filtro" + this.intSYS02CON)
        );

        this.Botonbar(this.WsLlaves);

        this.filtro_guardado = this.Select_grabar;
      },
      (error) => {
        Swal.fire({
          html:
            '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
            '<div class="col-4">' +
            ' <img src="assets/images/imageerror.png"> </img>' +
            "</div>" +
            ' <div class="col-8">' +
            "<h3>Error</h3><br>" +
            " <p>" +
            error +
            "</p>" +
            " </div> ",
        });
      }
    );
  }

  obtenerBusqueda(strListener) {
    let filtro = localStorage.getItem("busqueda" + strListener);

    if (filtro != null) {
      return filtro;
    } else {
      return null;
    }
  }

  Botonbar(llaves) {
    if (this.UrlBottomBar != "") {
      let json = this.toJSON("SELECT", llaves, this.UrlBottomBar);
      this.dataService
        .ConsultarWS(this.UrlBottomBar, json)
        .subscribe((datosResp: any) => {
          this.BottomBarData = datosResp.CamposMS;
        });
    }
  }

  pageChange(event) {
    this.currentPage = event;
  }

  actionBegin(args: any): void {
    const rowIndex = args.rowIndex;

    let gridInstance: any = (<any>document.getElementById("ListaEditableSync"))
      .ej2_instances[0];
    console.log("gridInstance", gridInstance);

    console.log("salvando " + args.requestType);
    // Metodos encontrados :
    // add
    // beginEdit
    // filterBeforeOpen
    // filterchoicerequest
    // sorting
    // filtering
    // refresh
    console.log("args", args);

    if (args.requestType === "save" || args.requestType === "delete") {
      if (args.requestType === "save") {
        let index = args.data.INDEX;

        if (index === "" || index === undefined) {
          // Insert
          let arrURL = this.DemeURLOperacionToolbar("A");

          let objJSON = this.toJSON(arrURL[1], [
            { ...args.data, ...this.WsLlaves[0] },
          ]);

          this.dataService.ConsultarWS(arrURL[0], objJSON).subscribe(
            (datosResp: any) => {
              // alert('INSERT OK');
            },
            (error) => {
              args.cancel = true;

              Swal.fire({
                html:
                  '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                  '<div class="col-4">' +
                  ' <img src="assets/images/imageerror.png"> </img>' +
                  "</div>" +
                  ' <div class="col-8">' +
                  "<h3>Error</h3><br>" +
                  " <p>" +
                  error +
                  "</p>" +
                  " </div> ",
              });
            }
          );
        } else if ((args.action = "edit")) {
          // Update
          if (args.requestType === "save") {
            const rowIndex = args.rowIndex;
            const gridInstance = (<any>(
              document.getElementById("ListaEditableSync")
            )).ej2_instances[0];
            const editedColumn = gridInstance.getColumns().find((col: any) => {
              return args.data[col.field] !== args.previousData[col.field];
            });

            let urlOperaciones = "";
            let operaciones: any = null;
            let arrURL = [];

            // busco la operación en línea
            for (let i = 0; i < this.operaciones.length; i++) {
              if (this.operaciones[i].Evento == "EDITAR_LINEA") {
                urlOperaciones = this.operaciones[i].URL;
                operaciones = this.operaciones[i];
                arrURL = Array(urlOperaciones, "");
              }
            }

            // se obtiene url operación onchange si no predomida el EDITAR_LINEA
            if (urlOperaciones == "") {
              arrURL = this.DemeURLOperacionEstructura(editedColumn.field);
            }

            this.msFormat.forEach((elementFormat) => {
              args.data[elementFormat] = args.data[elementFormat].toString();
            });
            let objJSON = this.toJSON(arrURL[1], [args.data]);

            // se valida la operación en línea y se carga el evento
            if (urlOperaciones != "") {
              objJSON.OPERACION = operaciones.Evento;
            }

            this.dataService.ConsultarWS(arrURL[0], objJSON).subscribe(
              (datosResp: any) => {
                //alert('UPDATE OK');
                for (const key in this.tableData2) {
                  if (this.tableData2[key].INDEX == index) {
                    let keys = Object.keys(datosResp.DATA[0]);
                    for (const k in keys) {
                      this.tableData2[key][keys[k]] =
                        datosResp.DATA[0][keys[k]];
                    }
                  }
                }
                gridInstance.refresh();
              },
              (error) => {
                args.cancel = true;

                Swal.fire({
                  html:
                    '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                    '<div class="col-4">' +
                    ' <img src="assets/images/imageerror.png"> </img>' +
                    "</div>" +
                    ' <div class="col-8">' +
                    "<h3>Error</h3><br>" +
                    " <p>" +
                    error +
                    "</p>" +
                    " </div> ",
                });
              }
            );
          }
        }
      } else if (args.requestType === "delete") {
        // Delete
        let arrURL = this.DemeURLOperacionToolbar("D");

        let objJSON = this.toJSON(arrURL[1], args.data);

        console.log(objJSON);
        this.dataService.ConsultarWS(arrURL[0], objJSON).subscribe(
          (datosResp: any) => {
            //    alert('DELETE OK');
          },
          (error) => {
            args.cancel = true;
            Swal.fire({
              html:
                '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                '<div class="col-4">' +
                ' <img src="assets/images/imageerror.png"> </img>' +
                "</div>" +
                ' <div class="col-8">' +
                "<h3>Error</h3><br>" +
                " <p>" +
                error +
                "</p>" +
                " </div> ",
            });
          }
        );
      }
      args.index =
        gridInstance.pageSettings.currentPage *
          gridInstance.pageSettings.pageSize -
        gridInstance.pageSettings.pageSize;
    }
  }

  actionComplete(e: any) {
    console.log("actionComplete", e);
  }

  toJSON(
    operacion: string,
    arr: any,
    url?: string,
    titulo?: string,
    extra?: string
  ) {
    let NavID = (
      Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
    ).toUpperCase();
    return JSON.parse(
      '{ "LLAVES"   :' +
        JSON.stringify(arr) +
        (url != null ? ', "URL"      :"' + url + '"' : "") +
        (titulo != null ? ', "TITULO"      :"' + titulo + '"' : "") +
        (extra != null ? "," + extra : "") +
        ', "NAV_ID"   : "' +
        NavID +
        '"' +
        ', "OPERACION": "' +
        operacion +
        '"}'
    );
  }

  AbrirReporteComponentePDFNav(json) {
    this.AbrirNuevoNav.emit(json);
  }

  DemeURLOperacionToolbar(strOperacion) {
    let strURL = "";
    let strEVENTO = "";

    for (let i = 0; i < this.toolbarResp.length; i++) {
      if (this.toolbarResp[i].Tipo === strOperacion) {
        strURL = this.toolbarResp[i].URL;
        strEVENTO = this.toolbarResp[i].Evento;
        break;
      }
    }

    if (strOperacion === "A" && strURL === "")
      return this.DemeURLOperacionToolbar("I");

    if (strOperacion === "I" && strURL !== "")
      strURL = "api/mantenimientos/InsertGenerico/" + this.intSYS02CON;

    return new Array(strURL, strEVENTO);
  }

  load() {
    (this.grid as GridComponent).element.addEventListener("mouseup", (e) => {
      const target = e.target as HTMLElement;
      if (target.classList.contains("e-rowcell")) {
        if ((this.grid as GridComponent).isEdit) (this.grid as GridComponent).endEdit();
  
        // USAR EL MÉTODO DE SYNCFUSION PARA OBTENER LOS DATOS DE LA FILA
        const rowInfo = (this.grid as GridComponent).getRowInfo(target);
        const rowData = rowInfo.rowData as any;
  
        if (this.SYS02TIP == "LES") {
          (this.grid as GridComponent).startEdit();
        } else {
          // PASAMOS DIRECTAMENTE EL OBJETO DE DATOS O SU INDEX REAL
          this.EventoClickLista(e, rowData.INDEX); 
        }
      }
    });
  }

  DemeURLOperacionEstructura(A03COD) {
    let strURL = "";
    for (let index = 0; index < this.estructuraResp.length; index++) {
      if (this.estructuraResp[index].A03COD == A03COD) {
        strURL = this.estructuraResp[index].UrlOnChange;
        break;
      }
    }

    return new Array(strURL, "");
  }

  DiferenciaTiempo() {
    return (this.TiempoFinal.getTime() - this.TiempoInicio.getTime()) / 1000.0;
  }

  dataURItoBlob(dataURI, strFORMATO, strType = "application/pdf") {
    if (strFORMATO == "XLS")
      strType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    if (strFORMATO == "application/xml") {
      strType = "application/xml";
    }
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: strType });
    return blob;
  }

  // código sección botones dinamicos
  EventoClickToolbar(clicked, url, formato?) {
    let seleccionados: any[] = [];
    let seleccionadas = this.grid.getSelectedRecords();
    seleccionados = seleccionadas.map((row) => row);
    console.log("Seleccionados", seleccionados);

    const btn = document.getElementById(clicked.target.id) as HTMLButtonElement;
    if (clicked.target.id == "INSERT") {
      if (this.mostrarModal) {
        // El evento es un insert para grabar datos desde una lista modal
        let arr: any[] = [];
        let blnExiste: boolean = false;
        this.objChecks.forEach((objCheck) => {
          if (objCheck.nativeElement.checked) {
            let index = objCheck.nativeElement.value;
            if (index != -1) {
              let llaves = this.DemeLlavesIndexJSON(index);
              arr.push(llaves);
            }
            blnExiste = true;
          }
        });

        if (blnExiste) {
          let arrLlaves =
            '  "FILTROS_OPCIONALES"   : [{}]' +
            ', "FILTROS_OBLIGATORIOS" : ' +
            JSON.stringify(this.WsLlaves) +
            (this.SYS02CON_PAPA_LD != null
              ? ', "SYS02CON_PAPA_LD" : ' +
                JSON.stringify(this.SYS02CON_PAPA_LD)
              : "");

          var jsonFiltros = this.toJSON(
            clicked.target.id,
            arr,
            null,
            null,
            arrLlaves
          );

          this.dataService.ConsultarWS(url, jsonFiltros, btn).subscribe(
            (datosResp: any) => {
              // Recargo los datos de la lista MODAL
              this._fetchData();
            },
            (error) => {
              Swal.fire({
                html:
                  '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                  '<div class="col-4">' +
                  ' <img src="assets/images/imageerror.png"> </img>' +
                  "</div>" +
                  ' <div class="col-8">' +
                  "<h3>Error</h3><br>" +
                  " <p>" +
                  error +
                  "</p>" +
                  " </div> ",
              });
            }
          );
        } else {
          Swal.fire({
            html:
              '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-4">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              "</div>" +
              ' <div class="col-8">' +
              "<h3>Error</h3><br>" +
              " <p>Debe seleccionar los registros con los que desea trabajar.</p>" +
              " </div> ",
          });
        }
      } else {
        // El evento es insert para abrir un mantenimiento en blanco
        let arr: any[] = [];
        let llaves = {};
        arr.push(llaves);

        let arrLlaves =
          '  "FILTROS_OPCIONALES"   : [{}]' +
          ', "FILTROS_OBLIGATORIOS" : ' +
          JSON.stringify(this.WsLlaves) +
          (this.SYS02CON_PAPA_LD != null
            ? ', "SYS02CON_PAPA_LD" : ' + JSON.stringify(this.SYS02CON_PAPA_LD)
            : "");

        // Armo el JSON
        let json = this.toJSON(clicked.target.id, arr, url, null, arrLlaves);
        this.AbrirURL(json);
      }
      this.checktodos(false);
    } else if (clicked.target.id == "WORKFLOW") {
      // almora 2023.07.01 Workflow
      let arr: any[] = [];
      let llaves = {};
      arr.push(llaves);

      let arrLlaves =
        '  "FILTROS_OPCIONALES"   : [{}]' +
        ', "WORKFLOW"             : ' +
        JSON.stringify(this.WORKFLOW) +
        ', "FILTROS_OBLIGATORIOS" : ' +
        JSON.stringify(this.WsLlaves);

      // Armo el JSON
      let json = this.toJSON(clicked.target.id, arr, url, null, arrLlaves);
      this.AbrirURL(json);
    } else if (
      clicked.target.id == "DOC10ARC" ||
      clicked.target.id == "PRO10ARC"
    ) {
      // almora 2023.07.05 Documentos
      let arr: any[] = [];
      let llaves = {};
      arr.push(llaves);

      let arrLlaves =
        '  "FILTROS_OPCIONALES"   : [{}]' +
        (this.DOC10ARC != null
          ? ', "DOC10ARC" : ' + JSON.stringify(this.DOC10ARC)
          : "") +
        (this.PRO10ARC != null
          ? ', "PRO10ARC" : ' + JSON.stringify(this.PRO10ARC)
          : "") +
        ', "FILTROS_OBLIGATORIOS" : ' +
        JSON.stringify(this.WsLlaves);

      // Armo el JSON
      let json = this.toJSON(clicked.target.id, arr, url, null, arrLlaves);
      this.AbrirURL(json);
    } else if (clicked.target.id == "INSERT_LISTA_SELECCION") {
      this.WsLlavesModal = this.WsLlaves;
      this.strWsURLModal = url;
      this.modalService.open(this.contenido, { size: "xl" });
    } else if (clicked.target.id == "EXPORTAR") {
      // El evento es Exportar
      let arr = { FILTROS_OBLIGATORIOS: [], FILTROS_OPCIONALES: [] };

      if (this.WsLlaves.length > 0) {
        arr.FILTROS_OBLIGATORIOS = this.WsLlaves;
      } else {
        arr.FILTROS_OBLIGATORIOS = [{}];
      }

      if (this.formFiltros != undefined) {
        let objForm = this.formatearFormulario(this.formFiltros);
        arr.FILTROS_OPCIONALES = [objForm];
      } else {
        arr.FILTROS_OPCIONALES = [{}];
      }

      let json = this.toJSON(clicked.target.id, arr, url);

      this.dataService.ConsultarWS(url, json, btn).subscribe(
        (datosResp: any) => {
          if (datosResp.Tipo == "ARCHIVO") {
            const blob = this.dataURItoBlob(datosResp.ARCHIVO_B64, "XLS");
            let fileURL = URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.download = "Exportar " + this.TituloPantalla + ".xls";
            link.href = fileURL;
            link.click();
          }
        },
        (error) => {
          Swal.fire({
            title: "Error",
            text: error,
            icon: "error",
          });
        }
      );
    } else if (clicked.target.id == "IMPRIMIR") {
      let parametros = url.split("/");
      let num = parametros.length;
      seleccionados.forEach((objCheck) => {
        let arr: any[] = [];

        let index = objCheck.INDEX;
        let llaves = this.DemeLlavesIndexJSON(index);
        arr.push(llaves);
        if (formato != "NAV") {
          this.VerReporte(
            parametros[num - 3],
            parametros[num - 2],
            parametros[num - 1],
            formato,
            arr
          );
        } else {
          this.AbrirReportePDFNav(
            parametros[num - 3],
            parametros[num - 2],
            parametros[num - 1],
            parametros[num - 4],
            arr
          );
        }
      });
    } else if (clicked.target.id == "ABRIR_MS") {
      let arr: any[] = [];
      seleccionados.forEach((objCheck) => {
        let index = objCheck.INDEX;
        let llaves = this.DemeLlavesIndexJSON(index);
        arr.push(llaves);
      });

      // Armo el JSON
      let json = this.toJSON("SELECT", arr, url);
      // Emito el evento para abrir un nuevo tab
      this.AbrirURL(json);
    } else if (clicked.target.id == "ABRIR_MS_MASIVO") {
      let arr: any[] = [];
      let blnExiste: boolean = false;

      seleccionados.forEach((objCheck) => {
        let index = objCheck.INDEX;
        let llaves = this.DemeLlavesIndexJSON(index);
        arr.push(llaves);
        blnExiste = true;
      });

      if (!blnExiste) {
        Swal.fire(
          "Error",
          "Debe seleccionar los registros con los que desea trabajar",
          "error"
        );

        return;
      }

      let arrLlaves =
        '  "FILTROS_OPCIONALES"   : [{}]' +
        ', "FILTROS_OBLIGATORIOS" : ' +
        JSON.stringify(arr);

      // Armo el JSON
      let json = this.toJSON("INSERT", arr, url);
      // Emito el evento para abrir un nuevo tab
      this.AbrirURL(json);
    } else if (clicked.target.id == "SUBIR_XML") {
      this.modalRef = this.modalService.open(DropzoneComponent, { size: "xl" });
      this.modalRef.componentInstance.retornaFiles.subscribe((files: any[]) => {
        this.dataService
          .ConsultarWS("api/archivos/recibir", JSON.stringify(files), btn)
          .subscribe((datos) => {});
      });
    } else if (clicked.target.id == "INSERT_OPERACIONES") {
      let arr: any[] = [];
      let llaves = {};
      arr.push(llaves);

      let arrLlaves =
        '  "FILTROS_OPCIONALES"   : [{}]' +
        ', "FILTROS_OBLIGATORIOS" : ' +
        JSON.stringify(this.WsLlaves);

      var jsonFiltros = this.toJSON(
        clicked.target.id,
        arr,
        null,
        null,
        arrLlaves
      );

      const btn = document.getElementById(
        clicked.target.id
      ) as HTMLButtonElement;
      var operacion = clicked.target.id;
      if (operacion == "INSERT_GENERICO") operacion = "Campo Insertado";
      else if (operacion == "UPDATE_GENERICO") operacion = "Campo Actualizado";
      else if (operacion == "DELETE_GENERICO") operacion = "Eliminado";
      this.dataService.ConsultarWS(url, jsonFiltros, btn).subscribe(
        (datosResp: any) => {
          this._fetchData(this.formFiltros);

          //alertas
          Swal.fire({
            toast: true,
            position: "bottom-end",
            icon: "success",
            text: operacion + " Correctamente",
            showConfirmButton: false,
            timer: 3000,
          });
        },
        (error) => {
          Swal.fire({
            html:
              '<div class="row" style="width:100%; overflow:auto;"> ' +
              '<div class="col-4">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              "</div>" +
              ' <div class="col-8">' +
              "<h3>  Error</h3>" +
              " <p> " +
              error +
              " </p>" +
              " </div> ",
          });
        }
      );
    } else if (clicked.target.id == "EJECUTAR_PROCESO") {
      let llaves = [this.reportesComponent?.filtroCampo.DemeFormulario()];
      let filtros = "{}";
      if (llaves[0] == undefined) {
        // almora 2024.11.05 Ejecutar Proceso , envio las llaves de la cejilla wizard
        filtros =
          '  "FILTROS_OPCIONALES"   : [{}]' +
          ', "FILTROS_OBLIGATORIOS" : ' +
          JSON.stringify(this.WsLlaves) +
          (this.SYS02CON_PAPA_LD != null
            ? ', "SYS02CON_PAPA_LD" : ' + JSON.stringify(this.SYS02CON_PAPA_LD)
            : "");
      }
      if (llaves[0] != 0) {
        var jsonFiltros = this.toJSON(
          clicked.target.id,
          llaves,
          null,
          null,
          filtros
        );
        const btn = document.getElementById(
          clicked.target.id
        ) as HTMLButtonElement;
        var operacion = clicked.target.id;
        operacion = "Operación realizada exitosamente.";
        this.dataService.ConsultarWS(url, jsonFiltros, btn).subscribe(
          (datosResp: any) => {
            //alertas
            Swal.fire({
              toast: true,
              position: "bottom-end",
              icon: "success",
              text: operacion,
              showConfirmButton: false,
              timer: 3000,
            });

            if (datosResp.NOTIFICACION != "") {
              Swal.fire({
                html:
                  '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                  '<div class="col-5">' +
                  ' <img src="assets/images/image-notifiacion.jpg"> </img>' +
                  "</div>" +
                  ' <div class="col-7">' +
                  "<h3>Advertencia</h3><br>" +
                  " <p>" +
                  datosResp.NOTIFICACION +
                  "</p>" +
                  " </div> ",
              });
            }
          },
          (error) => {
            Swal.fire({
              html:
                '<div class="row" style="width:100%; overflow:auto;"> ' +
                '<div class="col-4">' +
                ' <img src="assets/images/imageerror.png"> </img>' +
                "</div>" +
                ' <div class="col-8">' +
                "<h3>  Error</h3>" +
                " <p> " +
                error +
                " </p>" +
                " </div> ",
            });
          }
        );
      } else {
        Swal.fire("Error", "Debe diligenciar los campos requeridos", "error");
      }
    } else if (clicked.target.id == "CARGAR") {
      this.modalRef = this.modalService.open(DropzoneComponent, { size: "xl" });
      this.modalRef.componentInstance.limite = 1;
      this.modalRef.componentInstance.retornaFiles.subscribe((files: any[]) => {
        if (files.length > 0) {
          let peticion = { LLAVES: this.obtenerLlaves(), ARCHIVOS: files };
          this.enviarPeticion(clicked.target.id, url, JSON.stringify(peticion));
        }
      });
    } else if (clicked.target.id === 'DESCARGAR') {

      const seleccionados = this.grid.getSelectedRecords() as any[];
    
      if (!seleccionados || seleccionados.length === 0) {
        Swal.fire("Error", "Debe seleccionar los registros con los que desea trabajar", "error");
        return;
      }
    
      const arr: any[] = seleccionados.map(row => this.DemeLlavesIndexJSON(row.INDEX));
    
      const arrLlaves =
        '"FILTROS_OPCIONALES"   : [' + JSON.stringify(this.child?.DemeFormulario() ?? {}) + ']' +
        ', "FILTROS_OBLIGATORIOS" : ' + JSON.stringify(this.WsLlaves);
    
      const jsonFiltros = this.toJSON(clicked.target.id, arr, null, null, arrLlaves);
    
      this.enviarPeticion(clicked.target.id, url, jsonFiltros, 'descarga');
    
    } else if (clicked.target.id == "ABRIR_GANTT") {
      // El evento requiere seleccionar los checks
      let arr: any[] = [];
      let blnExiste: boolean = false;
      seleccionados.forEach((objCheck) => {
        let index = objCheck.INDEX;
        let llaves = this.DemeLlavesIndexJSON(index);
        arr.push(llaves);
        blnExiste = true;
      });

      if (blnExiste) {
        let objetoJSON = {
          FILTROS_OPCIONALES: arr,
          FILTROS_OBLIGATORIOS: this.WsLlaves,
        };

        let jsonString = JSON.stringify(objetoJSON);
        this.menuEvent.broadcast("ABRIR_NUEVO_TAB", {
          SYS02CON: 4,
          titulo: "Gantt",
          SYS02TIP: "GANTT",
          JSONllavesMantenimiento: jsonString,
        });
      } else {
        Swal.fire(
          "Error",
          "Debe seleccionar los registros con los que desea trabajar",
          "error"
        );
      }
    } else if (clicked.target.id == "ABRIR_CRONOGRAMA") {
      let arr: any[] = [];
      let blnExiste: boolean = false;
      seleccionados.forEach((objCheck) => {
        let index = objCheck.INDEX;
        let llaves = this.DemeLlavesIndexJSON(index);
        arr.push(llaves);
        blnExiste = true;
      });

      if (blnExiste) {
        let json = this.toJSON(
          "SELECT",
          arr,
          "api/mantenimientos/MantenimientoGenerico/lstPRO11ARC"
        );
        this.menuEvent.broadcast("ABRIR_NUEVO_TAB", {
          SYS02CON: "lstPRO11ARC",
          titulo: "Cronograma",
          JSONllavesMantenimiento: json,
        });
      } else {
        Swal.fire(
          "Error",
          "Debe seleccionar los registros con los que desea trabajar",
          "error"
        );
      }
    }else if (clicked.target.id == 'CHECKOUT') {
      // El evento requiere seleccionar los checks
      let arr: any[] = [];
      let blnExiste: boolean = false;
      seleccionados.forEach((objCheck) => {
        let index = objCheck.INDEX;
        let llaves = this.DemeLlavesIndexJSONAux(index);
        arr.push(llaves);
        blnExiste = true;
      });

      if (blnExiste) {
        let objetoJSON = {
          FILTROS_OPCIONALES: arr,
          FILTROS_OBLIGATORIOS: this.WsLlaves
        };

        let jsonString = JSON.stringify(objetoJSON);
        this.menuEvent.broadcast('ABRIR_NUEVO_TAB', { SYS02CON: 5, titulo: 'Procesar Pago', SYS02TIP: 'CHECKOUT', "JSONllavesMantenimiento": jsonString, SYS02CON_PAPA: this.intSYS02CON });
      } else {
        Swal.fire("Error", "Debe seleccionar los registros con los que desea trabajar", 'error');
      }
    } else {
      // El evento requiere seleccionar los checks

      let arr: any[] = [];
      let blnExiste: boolean = false;
      // ajuste para los nuevos check
      seleccionados.forEach((objCheck) => {
        let index = objCheck.INDEX;
        let llaves = this.DemeLlavesIndexJSON(index);
        arr.push(llaves);
        blnExiste = true;
      });
      console.log("Estos son los filtros array", arr);

      if (blnExiste) {
        let arrLlaves =
          '  "FILTROS_OPCIONALES"   : [{}]' +
          ', "FILTROS_OBLIGATORIOS" : ' +
          JSON.stringify(this.WsLlaves);
        var jsonFiltros = this.toJSON(
          clicked.target.id,
          arr,
          null,
          null,
          arrLlaves
        );
        console.log("Estos son los filtros json", jsonFiltros);
        var operacion = clicked.target.id;
        if (operacion == "INSERT_GENERICO") operacion = "Campo Insertado";
        else if (operacion == "UPDATE_GENERICO")
          operacion = "Campo Actualizado";
        else if (operacion == "DELETE_GENERICO") operacion = "Eliminado";
        // es aca...

        if (
          clicked.target.id == "DELETE_GENERICO" ||
          clicked.target.id == "DELETE_WS" ||
          clicked.target.id == "ANULAR"
        ) {
          var mensaje = "Está seguro de Eliminar?";
          if (clicked.target.id == "ANULAR")
            mensaje = "Está seguro de anular?";

          Swal.fire({
            title: mensaje,
            text: "No podrás revertir esto!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "No, cancelar!",
            confirmButtonText:
              clicked.target.id == "ANULAR"
                ? "Sí, anularlo"
                : "Si, eliminarlo",
          }).then((result) => {
            if (result.isConfirmed) {
              this.dataService.ConsultarWS(url, jsonFiltros, btn).subscribe(
                (datosResp: any) => {
                  this._fetchData(this.formFiltros);
                  //alertas
                  Swal.fire({
                    toast: true,
                    position: "bottom-end",
                    icon: "success",
                    text: operacion + " Correctamente",
                    showConfirmButton: false,
                    timer: 3000,
                  });
                },
                (error) => {
                  Swal.fire({
                    html:
                      '<div class="row" style="width:100%; overflow:auto;"> ' +
                      '<div class="col-4">' +
                      ' <img src="assets/images/imageerror.png"> </img>' +
                      "</div>" +
                      ' <div class="col-8">' +
                      "<h3>  Error</h3>" +
                      " <p> " +
                      error +
                      " </p>" +
                      " </div> ",
                  });
                }
              );
            }
          });
        } else {
          console.log("Estos son los filtros json", jsonFiltros);
          this.enviarPeticion(operacion, url, jsonFiltros);
        }
      } else {
        Swal.fire(
          "Error",
          "Debe seleccionar los registros con los que desea trabajar",
          "error"
        );
      }
    }
  }

  enviarPeticion(operacion, url, jsonFiltros, descarga?) {
    this.dataService.ConsultarWS(url, jsonFiltros).subscribe(
      (datosResp: any) => {
        this._fetchData();

        if (descarga == null) {
          //alertas
          Swal.fire({
            toast: true,
            position: "bottom-end",
            icon: "success",
            text: operacion + " Correctamente",
            showConfirmButton: false,
            timer: 3000,
          });
        } else {
          const blob = this.dataURItoBlob(datosResp.base64, datosResp.tipo);
          let fileURL = URL.createObjectURL(blob);
          if (datosResp.tipo == "application/pdf") {
            window.open(fileURL, "_blank");
          } else {
            let link = document.createElement("a");
            if (datosResp.nombre != null) {
              link.download = datosResp.nombre;
            } else {
              let tipoPartes = datosResp.tipo.split("/");
              if (tipoPartes.length > 1) {
                link.download = "documento." + tipoPartes[1];
              } else {
                link.download = "documento";
              }
            }
            link.href = fileURL;
            link.click();
          }
        }
      },
      (error) => {
        Swal.fire({
          html:
            '<div class="row" style="width:100%; overflow:auto;"> ' +
            '<div class="col-4">' +
            ' <img src="assets/images/imageerror.png"> </img>' +
            "</div>" +
            ' <div class="col-8">' +
            "<h3>  Error</h3>" +
            " <p> " +
            error +
            " </p>" +
            " </div> ",
        });
      }
    );
  }

  obtenerLlaves() {
    let arr = [];
    this.objChecks.forEach((objCheck) => {
      if (
        objCheck.nativeElement.checked &&
        objCheck.nativeElement.value != -1
      ) {
        let index = objCheck.nativeElement.value;
        let llaves = this.DemeLlavesIndexJSON(index);
        arr.push(llaves);
      }
    });

    return arr;
  }

  AbrirURL(json) {
    if (this.MsDetalle == "S") {
      // Abro un URL en mantenimiento interno
      this.WsMsDataInterno = json;
    } else {
      // Emito el evento para abrir un nuevo tab
      this.AbrirNuevoNav.emit(json);
    }
  }

  AbrirReportePDFNav(
    intSYS02CON: string,
    intSYS10CON: string,
    intTSTAMP: string,
    strSYS10DES: string,
    llaves?
  ) {
    if (llaves == undefined) {
      llaves = this.WsLlaves;
    }

    const filtrosOpcionales = this.formFiltros != null 
    ? JSON.stringify(this.formatearFormulario({...this.formFiltros})) 
    : '{}';

    let arr = JSON.parse(
      '{    "FILTROS_OPCIONALES"   : [' +
        filtrosOpcionales +
        "]" +
        ' , "SYS02CON"   : "' +
        intSYS02CON +
        '" ' +
        ' , "SYS10CON"   : ' +
        intSYS10CON +
        ' , "FORMATO"    : "PDF" ' +
        ' , "TSTAMP"     : ' +
        intTSTAMP +
        ' , "TITULO"     : "' +
        strSYS10DES +
        '"' +
        ' , "FILTROS_OBLIGATORIOS" : ' +
        JSON.stringify(llaves) +
        "}"
    );

    // Armo el JSON
    let json = this.toJSON(
      "ABRIR_REPORTE_PDF",
      arr,
      "api/mantenimientos/VerReporte/" +
        intSYS02CON +
        "/" +
        intSYS10CON +
        "/" +
        intTSTAMP,
      strSYS10DES
    );
    this.AbrirNuevoNav.emit(json);
  }

  VerReporte(
    intSYS02CON: string,
    intSYS10CON: string,
    intTSTAMP: string,
    strFORMATO: string,
    llaves?
  ) {
    if (llaves == undefined) {
      llaves = this.WsLlaves;
    }

    const filtrosOpcionales = this.formFiltros != null 
    ? JSON.stringify(this.formatearFormulario({...this.formFiltros})) 
    : '{}';

    let strjson =
      '{    "FILTROS_OPCIONALES"   : [' +
      filtrosOpcionales +
      "]" +
      ' , "SYS02CON"   : "' +
      intSYS02CON +
      '" ' +
      ' , "SYS10CON"   : ' +
      intSYS10CON +
      ' , "FORMATO"    : "' +
      strFORMATO +
      '" ' +
      ' , "TSTAMP"     : ' +
      intTSTAMP +
      ' , "TITULO"     : ""' +
      ' , "FILTROS_OBLIGATORIOS" : ' +
      JSON.stringify(llaves) +
      "}";

    let arr = JSON.parse(strjson);
    let json = this.toJSON(
      "ABRIR_REPORTE_PDF",
      arr,
      "api/mantenimientos/VerReporte/" +
        intSYS02CON +
        "/" +
        intSYS10CON +
        "/" +
        intTSTAMP,
      ""
    );

    this.dataService
      .ConsultarWS(
        "api/mantenimientos/VerReporte/" +
          intSYS02CON +
          "/" +
          intSYS10CON +
          "/" +
          intTSTAMP,
        json
      )
      .subscribe(
        (datosResp: any) => {
          const base64 = datosResp.DATA[0].REPORTE_PDF_BASE64;
          const blob = this.dataURItoBlob(base64, strFORMATO);
          let fileURL = URL.createObjectURL(blob);
          window.open(fileURL, "_blank");
        },
        (error) => {
          this.tipoReporte = null;
          Swal.fire({
            title: "Error",
            text: error,
            icon: "error",
          });
        }
      );
  }

  formatearFormulario(form) {
    for (const key in form) {
      if (form[key] == null) {
        form[key] = "";
      }
      if (Array.isArray(form[key])) {
        form[key] = "'" + form[key].join("','") + "'";
      }
      if (form[key] == Number(form[key])) {
        form[key] = String(form[key]);
      }

      let elemento = this.getObtenerCodigoCampo(key);
      if (elemento.A03TIP === "datetime" && form[key] != "") {
        form[key] = formatDate(form[key], "dd/MM/yyyy", "en");
      }
    }
    return form;
  }

  getObtenerCodigoCampo(label) {
    for (const i in this.estructura) {
      if (this.estructura[i].A03COD == label) {
        return this.estructura[i];
      }
    }
    return null;
  }

  DemeLlavesIndexJSON(index) {
    let row = null;

    for (const key in this.tableData2) {
      if (this.tableData2[key].INDEX == index) {
        row = this.tableData2[key];
        break;
      }
    }
    var arr = {};
    for (let i = 0; i < this.llaves.length; i++) {
      let llave = this.llaves[i];

      let encontro = false;
      let valor = "";
      for (let j = 0; j < this.tableData3.length; j++) {
        if (llave == this.tableData3[j].codigo) {
          valor = this.tableData3[j].des.find(
            (element) => element.A09DES == row[llave]
          );
          valor = valor["A09COD"];
          encontro = true;
          break;
        }
      }
      if (encontro == false && row != null) {
        valor = row[llave];
      }
      arr[llave] = valor;
    }

    return arr;
  }

  DemeLlavesIndexJSONAux(index) {
    let arr = {};

    for (const key in this.tableData2) {
      if (this.tableData2[key].INDEX == index) {
        const row = this.tableData2[key];
        arr[key] = row;
        break;
      }
    }

    return arr;
  }

  get tieneAcciones(): boolean {
    return this.operaciones?.some(op => op.SYS16MET === 'S') ?? false;
  }

}
